import { element } from 'prop-types';
import React, { Component } from 'react'
import CustomLightbox from "../components/custom-lightbox"
import Recaptcha from 'react-google-recaptcha'

import Load from '../assets/images/load.png'
import { navigate } from 'gatsby';

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class Form extends Component {

  state = {
    form: {},
  }

  handleChange = e => {
    let { form } = this.state
    if (e.target.name === 'type') {
      let current = form[e.target.name] || ''
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + ' ' + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(' ' + e.target.value, '')
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = value => {
    this.setState({ "g-recaptcha-response": value });
  }

  handleSubmit = async (e) => {
    let { form } = this.state
    e.preventDefault()
    this.setState({ result: 'success' })
    const data = encode({ 
      name: form['name'],
      email: form['email'],
      phone: form['phone'],
      type: form['type'],
      office: this.props.office.title,
      office_email: this.props.office.email,
      message: form['message'],
    })
    await fetch("https://hooks.zapier.com/hooks/catch/2181815/bfsxd0j/?"+data)
  }
  render() {
    const data = this.props

    let props = {
      ref: 'form',
      name: 'office_contact',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success') {

      navigate('/thank-you');
      return (
        <div className="signup__nav">
          <p>Thanks for getting in contact with us.<br /> A member of our team will be in touch soon.</p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <form {...props}>
          <h4 className='office'>Contact <span>{data.office.title}</span></h4>
          <input type='text' className='name' name='name' placeholder='Your Name' onChange={this.handleChange} required />
          <input type='email' className='email' name='email' placeholder='Email' onChange={this.handleChange} required />
          <input type='text' className='number' name='phone' placeholder='Contact Number' onChange={this.handleChange} required />
          <p>How can we help?</p>
          <ul>
            <li>
              <input id={`office_checkbox_0`} className='boxes' name='type' type='checkbox' value='Buy' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_0`}>Buy</label>
            </li>
            <li>
              <input id={`office_checkbox_1`} className='boxes' name='type' type='checkbox' value='Lease' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_1`}>Lease</label>
            </li>
            <li>
              <input id={`office_checkbox_2`} className='boxes' name='type' type='checkbox' value='Sell' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_2`}>Sell</label>
            </li>
            <li>
              <input id={`office_checkbox_3`} className='boxes' name='type' type='checkbox' value='Property Management' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_3`}>Property Management</label>
            </li>
            <li>
              <input id={`office_checkbox_4`} className='boxes' name='type' type='checkbox' value='Projects' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_4`}>Projects</label>
            </li>
            <li>
              <input id={`office_checkbox_5`} className='boxes' name='type' type='checkbox' value='Creative' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_5`}>Creative</label>
            </li>
            <li>
              <input id={`office_checkbox_6`} className='boxes' name='type' type='checkbox' value='Apply' onChange={this.handleChange} />
              <label htmlFor={`office_checkbox_6`}>Apply</label>
            </li>
          </ul>
          <textarea row='6' placeholder='Leave us a message' name='message' onChange={this.handleChange} />
          <div className='recaptcha__wrapper'>
            <Recaptcha
              ref='recaptcha'
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className='contactbtn btn' type='submit'>Send Message</button>
        </form>
      </div>  
    )
  }
}

class ContactOffices extends Component {

  state = {
    selectedOffice: 0,
    formActive: false,
    isLightboxOpen: false,
    lightboxIndex: 0,
  }

  openForm = (i) => {
    this.setState({
      formActive: true,
      selectedOffice: i 
    })
  }

  closeLightbox = () => {
    this.setState({ isLightboxOpen: false })
  }

  render() {
    const data = this.props
    let { selectedOffice, formActive, isLightboxOpen, lightboxIndex } = this.state
    const lightboxContent = data.office[selectedOffice].gallery.map(image => ({ type: "image", url: image.localFile.publicURL }))

    const prevContent = () => {
      if (lightboxIndex === 0) {
        this.setState({ lightboxIndex: lightboxContent.length - 1 })
      } else {
        this.setState({ lightboxIndex: lightboxIndex - 1 })
      }
    }
    const nextContent = () => {
      if (lightboxIndex === lightboxContent.length - 1) {
        this.setState({ lightboxIndex: 0 })
      } else {
        this.setState({ lightboxIndex: lightboxIndex + 1 })
      }
    }

    return (
      <>
        <section className="contact-offices">
          <div className="contact-offices__inner container">
            { data.office.map((el, i) => (
              <div className="contact-offices__item" key={i}>
                <div 
                  className={`contact-offices__item--top ${el.gallery.length > 0 ? 'has-gallery' : ''}`} 
                  onClick={() => el.gallery.length > 0 && this.setState({ selectedOffice: i, isLightboxOpen: true, lightboxIndex: 0})}>
                  <img src={el.picture.localFile.publicURL} alt={`WhiteFox - ${el.title}`} />
                </div>
                <div className="contact-offices__item--bottom">
                  <div className='address'>
                    <h6>{el.title}</h6>
                    <p>{el.address}<br />{el.suburb}</p>
                  </div>
                  <div className="details">
                    <p className="email"><a href={`mailto:${el.email}`}>Email</a></p>
                    <p className="phone"><a href={`tel:${el.phone}`}>{el.phone}</a></p>
                  </div>
                  <button className='btn' type='button' onClick={() => this.openForm(i)}>
                    Contact Online
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>
        <div className={`${formActive ? 'signup active' : 'signup'}`}>
          <Form office={data.office[selectedOffice]} />
          <div className="signup__close">
            <button className={ formActive ? 'active' : '' } onClick={() => this.setState({ formActive: false })}>
              <img src={Load} alt="Close sign up form"/>
            </button>
          </div>
        </div>
        { isLightboxOpen && (
          <CustomLightbox
            lightboxContent={lightboxContent}
            closeLightbox={this.closeLightbox}
            lightboxIndex={lightboxIndex}
            prevContent={prevContent}
            nextContent={nextContent}
          />
        )}
      </>
    )
  }
}

export default ContactOffices
